class MultiRange extends HTMLElement {
  parentForm = null;

  input_min = null; //HTMLInputElement;
  input_max = null; //HTMLInputElement;
  inputs = []; //NodeListOf<HTMLInputElement>;

  range_gap = 1;

  value_min = 0;
  value_max = 0;

  display_element_min = null;
  display_element_max = null;

  display_value_min = 0;
  display_value_max = 0;

  display_filter = null;
  display_filters = [];

  range_bar = null;

  constructor() {
    super();

    this.inputs = this.querySelectorAll('input[type="range"');
    this.input_min = this.inputs[0];
    this.input_max = this.inputs[1];

    this.range_gap = this.getAttribute('data-range-gap') * 1 || 1;

    this.display_element_min = this.querySelector('.multi-range__display--min');
    this.display_element_max = this.querySelector('.multi-range__display--max');

    this.display_value_min = this.display_element_min.textContent;
    this.display_value_max = this.display_element_max.textContent;

    this.parentForm = this.closest('form');

    this.display_filter = this.getAttribute('data-range-filter') || null;

    this.range_bar = this.querySelector('.multi-range__inputs__bar');

    this._onInputMinChange = this.onInputMinChange.bind(this);
    this._onInputMaxChange = this.onInputMaxChange.bind(this);
    this._onParentFormClear = this.onParentFormClear.bind(this);
    this._onInputChange = this.onInputChange.bind(this);

    this.initializeFilters();
  }

  connectedCallback() {
    this.addEventListeners();

    this.onInputChange();

    this.setAttribute('data-ready', true);
  }

  addEventListeners() {
    this.input_min.addEventListener('input', this._onInputMinChange);
    this.input_max.addEventListener('input', this._onInputMaxChange);
    if (this.parentForm) {
      this.parentForm.addEventListener('clear', this._onParentFormClear);
    }
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  removeEventListeners() {
    this.input_min.removeEventListener('input', this._onInputMinChange);
    this.input_max.removeEventListener('input', this._onInputMaxChange);
    if (this.parentForm) {
      this.parentForm.removeEventListener('clear', this._onParentFormClear);
    }
  }

  initializeFilters() {
    if (this.display_filter) {
      if (this.display_filter == 'currency') {
        this.addFilter(value => `£${value}`);
      }
      if (this.display_filter == 'percentage') {
        this.addFilter(value => `${value}%`);
      }
      if (this.display_filter == 'yearmonths') {
        this.addFilter(value => {
          const valueMonths = value % 12;
          const valueYears = Math.floor(value / 12);

          const formattedMonths = valueMonths < 10 ? `0${valueMonths}` : valueMonths;
          const formattedYears = valueYears < 10 ? `0${valueYears}` : valueYears;

          return `${formattedYears}:${formattedMonths}`;
        });
      }
    }
  }

  onInputChange() {
    this.onInputMinChange(false);
    this.onInputMaxChange(false);

    this.updateDisplay();

    this.dispatchEvent(new Event('change'));
    this.dispatchEvent(new Event('input'));
  }
  onInputMinChange(fire_triggers = true) {
    if (this.input_min.value * 1 > this.input_max.value * 1 - this.range_gap)
      this.input_min.value = this.input_max.value * 1 - this.range_gap;

    this.value_min = this.input_min.value;

    if (fire_triggers) {
      this.updateDisplay();

      // Trigger change event
      this.dispatchEvent(new Event('change'));
      this.dispatchEvent(new Event('input'));
    }
  }
  onInputMaxChange(fire_triggers = true) {
    if (this.input_max.value * 1 < this.input_min.value * 1 + this.range_gap)
      this.input_max.value = this.input_min.value * 1 + this.range_gap;

    this.value_max = this.input_max.value;

    if (fire_triggers) {
      this.updateDisplay();

      // Trigger change event
      this.dispatchEvent(new Event('change'));
      this.dispatchEvent(new Event('input'));
    }
  }

  get value() {
    return [this.value_min, this.value_max];
  }
  set value(values) {
    this.value_min = values[0];
    this.value_max = values[1];
    this.input_min.value = this.value_min;
    this.input_max.value = this.value_max;
  }

  addFilter(filter) {
    this.display_filters.push(filter);
    this.updateDisplay();
  }
  removeFilter(filter) {
    this.display_filters = this.display_filters.filter(f => f !== filter);
    this.updateDisplay();
  }
  updateDisplay() {
    this.display_value_min = this.value_min;
    this.display_value_max = this.value_max;

    // Apply filters
    this.display_filters.forEach(filter => {
      this.display_value_min = filter(this.display_value_min);
      this.display_value_max = filter(this.display_value_max);
    });

    this.display_element_min.textContent = this.display_value_min;
    this.display_element_max.textContent = this.display_value_max;

    let read_value_min = this.value_min;
    let read_value_max = this.value_max;

    if (this.display_filter == 'yearmonths') {
      read_value_min = `${Math.floor(read_value_min / 12)} years, ${read_value_min % 12} months`;
      read_value_max = `${Math.floor(read_value_max / 12)} years, ${read_value_max % 12} months`;
    }

    this.input_min.setAttribute('aria-valuetext', read_value_min);
    this.input_max.setAttribute('aria-valuetext', read_value_max);

    this.updateRangeBar();
  }
  updateRangeBar() {
    const range = this.input_max.value - this.input_min.value;
    const range_max = this.input_max.max - this.input_max.min;
    const range_min = this.input_min.value - this.input_max.min;
    const range_percentage = (range / range_max) * 100;
    const range_percentage_min = (range_min / range_max) * 100;
    this.range_bar.style.left = `${range_percentage_min}%`;
    this.range_bar.style.width = `${range_percentage}%`;
  }

  onParentFormClear() {
    setTimeout(() => {
      this.onInputChange();
    }, 1);
  }
}

customElements.define('multi-range', MultiRange);
